import React, { useState } from "react";

import { observer } from "mobx-react";
import { useTheme } from "styled-components";

import { useAppState } from "../../contexts/ApplicationStateProvider";
import { useStores } from "../../contexts/StoreContext";
import Icon from "../../shared/Icon/Icon";
import Video from "../../shared/components/Video/Video";
import useDevice from "../../shared/customHooks/useDevice";
import MobileHomepage from "./MobileHomepage";
import InteractiveRoleBrowser from "./RoleBrowserOverlay";
import StyledLink from "./StyledLink";

function OverlayText() {
  return (
    <>
      <h2 className="text-uppercase">Welcome to Gails</h2>
      <h2 className="text-uppercase">Take a look around</h2>
      <h5 className="text-uppercase">Turn your sound on!</h5>
    </>
  );
}

function InteractiveHomepage() {
  const { setIsInteractive } = useAppState();
  const { homepageStore } = useStores();
  const timeToStop = 26;
  const [isPaused, setIsPaused] = useState();
  const { isMobile } = useDevice();
  const { footerBackgroundColor } = useTheme();
  const { desktopVimeoId } = homepageStore;

  if (isMobile) {
    return <MobileHomepage />;
  }

  return (
    desktopVimeoId && (
      <Video
        controls={false}
        endVideoView={<InteractiveRoleBrowser />}
        headingText={<OverlayText />}
        isPaused={isPaused}
        overlayColor={footerBackgroundColor}
        setIsPaused={setIsPaused}
        timeToStop={timeToStop}
        vimeoID={desktopVimeoId}
        withOverlay
      >
        <StyledLink
          className="pt-5 mt-auto d-flex text-uppercase"
          href="/"
          onClick={() => setIsInteractive(false)}
        >
          <Icon className="me-4" icon="arrowLeft" size={36} />
          Is our interactive experience not to your taste?
          <br />
          Visit our original employment site
        </StyledLink>
      </Video>
    )
  );
}

export default observer(InteractiveHomepage);
